<template>
    
    <v-container class="grey lighten-5" >
 <v-row justify="center" >
    <v-col class="mb-6">

  <div class="text-center">
        <h2>CARGOS</h2> <br>
        </div>

<v-card  :elevation="4"
          class="pa-2"
        
        >
<div class="text-center">
       <form>


<v-select
      v-model="select0"
      :items="empresas"
      item-text="nombre"
      item-value="id"
      label="Seleccione sede"
      required
      @change="getEmpresadetails"
     
    ></v-select>


<v-select
      v-model="select1"
      :items="perfiles"
      label="Seleccione Perfil"
      required
      item-text="nombrePerfilCargo"
      item-value="id"
      @change="getPerfil"       
       

    ></v-select>
   
    <v-text-field
            v-model="cedula"
            :counter="20"
            label="Nombre Cargo"
            required
            v-on:keyup="hideMessage"
          ></v-text-field>

<v-btn @click="actualizarPerfil" block color="primary">Actualizar cargo</v-btn><br>
    <v-btn @click="createPerfil" block color="primary">Crear cargo</v-btn><br>
     
    
  </form>


  </div>

 

</v-card>
<br>
<v-card>
   
 
 <v-data-table
     v-model="selected2"
    :headers="headers"
    :items="tabla"
    :single-select="true"
    item-key="id"
    
    class="elevation-1"
    show-select
    >

    </v-data-table> 
  

    <div class="text-center pt-2">

     
     <br><br>
     <v-btn @click="eliminarPerfil" block color="primary">Eliminar cargo</v-btn><br>

    </div>
 </v-card>
    
    </v-col>

  </v-row>


  <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">Reactivacion de usuarios</v-card-title>

        <v-card-text>
          Desea reactivar el usuario {{nombre}} de nuevo ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="activateUserAgain"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


</v-container>

</template>


<script>

import axios from "axios";
import { actionStore } from "./CheckerLocalStorage";
import Tabla from "./Tabla";


 export default {

   components:{

     Tabla

   },

    data: vm => ({
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      e4: null,
      dropdown_font: ['Arial', 'Calibri', 'Courier', 'Verdana'],
      perfiles: [{ id: 1,nombrePerfilCargo: 'one'}],
      cargoNombre:[{ id: 1,nombrePerfilCargo: 'one'}],
      fecha:'',
      empresas: [{ id: 1,nombrePerfilCargo: 'one'}],
      select0:null,
      select1:null,
      select2:null,
      cedula:'',
      nombre:'',
      pagination:'',
      statusFailure:false,
      statusEmpty:false,
      statusCreated:false,
      search: '',
      selected2: [],
      singleSelect: true,
      empresaSelected:{},
      statusLoader:false,
      

      hora:'',
      url1:'',

      //*******TABLE PAGINATION */
        page: 0,
        pageCount: 0,
        itemsPerPage: 10,
        headers: [
          {
            text: 'ID',
            align: 'left',
           // value: 'id',
             value: 'fkIdPerfilCargo',
          },
          { text: 'CARGO', value: 'cargoNombre' },
         //{ text: 'CARGO', value: 'nombrePerfilCargo' },
       
         
        ],
        tabla:[],
             
        //*******TABLE PAGINATION */



    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },
      msg() {
      const selectedRow = this.selected[0];
        console.log(selectedRow);
      }
    },

    watch: {
      date () {
        this.dateFormatted = this.formatDate(this.date)
        this.fecha = "Fecha seleccionada: "+this.dateFormatted
      },
      e4 (){

        this.hora = "Hora seleccionada: "+this.e4
        console.log('it has cahnged..'+this.e4);

      },
     
      
    },

    beforeMount(){

     

    },

     mounted () {

      // this.getPerfiles2();
       let that = this;

         axios.get(actionStore.methods.getInfoEmpresa().urlServer+'/register/sedes?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId)
            .then(function (response) {
                //console.log(response);
                that.empresas = response.data;
        }).then();


    },

    methods: {

    getPerfiles2:function(){
          let that = this;
          this.url1 = actionStore.methods.getInfoEmpresa().urlServer+'/register/perfilcargos/'+this.empresaSelected.id+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
          axios.get(this.url1)
            .then(function (response) {
                that.perfiles = response.data;
          }).then();

         // this.fillTable();

      },

      actualizarPerfil:function(){

        if(Object.keys(this.empresaSelected).length!=0){

        if(this.selected2.length>0){

          if(this.cedula!=""){

            let that = this;
            let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/updatecargo/'+this.cedula+'/'+this.selected2[0].id+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                        })
                        .then(function (response) {

                          
                          that.getPerfil();
                          that.cedula = "";
                         
                        })
                        .catch(function (error) {
                          console.log('from error..*.');
                      
                          
                        });


          }
        }else{

          
          alert('seleccione un perfil primero');

           
        }

       }else{

          alert('seleccione una sede primero');

        }
       

      },

      eliminarPerfil:function(){

         if(Object.keys(this.empresaSelected).length!=0){
        if(this.selected2.length>0){
           console.log("deleting "+this.selected2[0].id);
              
             let that = this;
             let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/deletecargo/'+this.selected2[0].id+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                        })
                        .then(function (response) {

                          
                          that.getPerfil();
                         
                        })
                        .catch(function (error) {
                          console.log(error);
                          console.log('from error..*.');
                      
                          
                        }); 
                

          }

         }else{

          alert('seleccione una sede primero');

        }


      },

      createPerfil:function(){


      if(Object.keys(this.empresaSelected).length!=0){
        if(this.cedula!=""){

          let that = this;
          let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/createcargo/'+this.cedula+'/'+this.select1+'/'+this.empresaSelected.id+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                        })
                        .then(function (response) {

                          that.cedula="";
                          
                          that.getPerfil();
                         
                        })
                        .catch(function (error) {
                          console.log('from error..*.');
                      
                          
                        }); 



        }
      }else{

          alert('seleccione una sede primero');

        }

      },

      getEmpresadetails:function(){

        this.empresas.map(item=>{

          if(item.id==this.select0){

            console.log(item);
            this.empresaSelected = item;

            this.getPerfiles2();

          }

        })

      },

      getPerfiles:function(){
          let that = this;
          this.url1 = actionStore.methods.getInfoEmpresa().urlServer+'/register/perfilcargos?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
          axios.get(this.url1)
            .then(function (response) {
                
                that.tabla = response.data;
          }).then();

      },

      activateUserAgain(){

        this.dialog=false;
        console.log("the ID  is "+ this.cedula);
        let that = this;
     
        let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/disableuser/'+this.cedula+'/1/'+this.select1+'/'+this.select2+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                        })
                        .then(function (response) {
                          
                          that.enablingUser();
                         
                        })
                        .catch(function (error) {
                          console.log('from error..*.');
                      
                          
                        }); 

      },

      enablingUser: function(){

      let url = actionStore.methods.getEndpoints().URL_BACKEND+'/info/updateuser/'+this.cedula+'/1';

      let that = this;
      console.log(url);
                      axios.post(url, {
                        })
                        .then(function (response) {
                          
                          //console.log("updated user..");
                          that.fillTable();
                          that.statusLoader=false;
                         
                        })
                        .catch(function (error) {
                          

                            console.log("the error is ");
                            console.log(error);
                      
                          
                        }); 

      },

      selectedItems:function(){
 
               console.log(this.selected);


               let that = this;
               this.selected.map(item=>{

               let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/disableuser/'+item.cedula+'/0/0/0?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
               console.log(url);
                      axios.post(url, {
                        })
                        .then(function (response) {
                          
                          that.disablingUser(item.cedula,that);
                         
                        })
                        .catch(function (error) {
                          console.log('from error...');
                      
                          
                        }); 


            })

            

        },

        disablingUser:function(idSelectedUser,that){


          let url = actionStore.methods.getEndpoints().URL_BACKEND+'/info/updateuser/'+idSelectedUser+'/0';
                      axios.post(url, {
                        })
                        .then(function (response) {
                          
                          //console.log("updated user..");
                          that.fillTable();
                         
                        })
                        .catch(function (error) {
                          console.log('from error...');
                      
                          
                        }); 


        },

       onPageChange: function () {
          //console.log('page '+this.page);
          this.fillTable();
       },


      fillTable:function(){


          let that = this;
          let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/usuariospaginados/'+this.page+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
          axios.get(url)
              .then(function (response) {
                
                  that.pageCount = parseInt(response.data.totalPages);
                  that.tabla = response.data.infoUsuario;
                  
          }).then();

      },
      hideMessage:function(){

         this.statusEmpty = false;
         this.statusCreated = false;
         this.statusFailure = false;
      }, 

      getCargo:function(){

        this.hideMessage();
        //console.log('cargo selected..'+this.select2);

      },

      getPerfil: function(){


        let that = this;
          this.url1 = actionStore.methods.getInfoEmpresa().urlServer+'/register/cargos/'+this.select1+'/'+this.empresaSelected.id+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
          console.log(actionStore.methods.getInfoEmpresa().urlServer+'/register/cargos/'+this.select1+'/'+this.empresaSelected.id+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId);
          axios.get(this.url1)
            .then(function (response) {
                
                that.tabla = response.data;
          }).then();

         /*
          let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/cargos/'+this.select1+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
          let that = this;
          axios.get(url)
            .then(function (response) {
           
              console.log(response.data);
                that.tabla = response.data;
          })*/

        
      },



      finish:function(){


       
        if(this.select1!='' && this.select2!='' && this.nombre!='' && this.cedula!=''){

             let that = this;
             let responsedata = '';
             let cedula1 = this.cedula;
             let nombre1 = this.nombre;
             
             this.statusLoader=true;
             let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/checkuser/'+cedula1+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
             //console.log("URL 1 "+url);
             axios.get(url)
                .then(function (response) {
                  
                    //console.log(response);
                    if(response.data=='EXISTS'){


                      console.log("from exists..");
                      let url2 = actionStore.methods.getInfoEmpresa().urlServer+'/register/checkuserstatus/'+cedula1+'?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;

                      axios.post(url2, {
                        })
                        .then(function (response2) {
                        
                          if(response2.data=='EXISTS'){

                              console.log("do you want to reactivate the USER again ?");
                              //that.activateUserAgain(cedula1);
                              that.dialog=true;

                          }else{

                             that.statusFailure=true;
                             that.statusLoader=false;

                          }

                        
                        })
                        .catch(function (error) {
                          //console.log('from error.*..');
                       
                        }); 




                     

                    }else{


                      let url = actionStore.methods.getInfoEmpresa().urlServer+'/register/createuser?tenantId=tenantId'+actionStore.methods.getInfoEmpresa().tenantId;
                      axios.post(url, {
                          fkIdPerfil:that.select1,
                          fkIdCargo:that.select2,
                          cedula:that.cedula,
                          nombre:that.nombre.toUpperCase(),
                          huella:""
                        })
                        .then(function (response) {
                         
                          //console.log('from success...');
                          //console.log(response);
                          //console.log(response.data);
                          responsedata = response.data;

                          that.creatingUser(responsedata,cedula1, nombre1, actionStore.methods.getInfoEmpresa().urlServer,that );
                          
                          that.cedula='';
                          that.nombre = '';
                        })
                        .catch(function (error) {
                          console.log('from error...');
                        
                          if(error.response.status==302){

                              that.statusFailure = true;
                              that.statusLoader=false;
                          }
                          
                        }); 


                    }
                    
             })
          
              

            
        }else{

            //console.log('campos vacios');
            this.statusEmpty = true;
        }


      },


      creatingUser:function(idUser, cedula, nombre, urlServer, that ){

          console.log('calling from second method');


            let url = actionStore.methods.getEndpoints().URL_BACKEND+"/api/auth/signup/user";
             axios.post(url, {
                    name:nombre,
                    username:cedula,
                    email:cedula+"@none.com",
                    password:cedula,
                    
                    fkIdTenantDetails:actionStore.methods.getInfoEmpresa().tenantId,
                    usuarioTenantId:idUser,
                    activo:"si"
                    


                              })
              .then(function (response) {
                
                 that.statusCreated = true;
                 that.statusLoader=false;

                 that.fillTable();
                //console.log('from success...');
                //console.log(response);
                
              })
              .catch(function (error) {

                console.log(error.message);
                //console.log('from error...2');
                if(error.response.status==400){

                              that.statusFailure = true;
                              that.statusLoader=false;
                          }
                
              });   



      },


      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${year}-${month}-${day}`
      },
      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },
    },
  }


</script>

